function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20.000000, -19.000000)",
  fill: "#000E20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.0764026,19.521962 C32.417569,19.9007796 32.4156381,20.4686848 32.0905427,20.8445113 L32.0025478,20.9342457 L24.1565679,27.999168 L44.3333333,28 C44.8461692,28 45.2688405,28.3860402 45.3266056,28.8833789 L45.3333333,29 C45.3333333,29.5522847 44.8856181,30 44.3333333,30 L44.3333333,30 L24.0585679,29.999168 L32.0025478,37.1539896 C32.4129337,37.5235865 32.4459996,38.1558875 32.0764026,38.5662733 C31.7068056,38.9766592 31.0745046,39.0097251 30.6641188,38.6401281 L20.9974522,29.9342457 C20.7543185,29.7152775 20.6436236,29.4041004 20.6706376,29.101491 L20.6666667,29 C20.6666667,28.9840164 20.6670417,28.9681204 20.6677833,28.9523202 L20.6774007,29.0443139 C20.6358809,28.7644687 20.7139541,28.4711141 20.9074639,28.246034 L20.9974522,28.1539896 L30.6641188,19.4481072 C31.0745046,19.0785102 31.7068056,19.1115761 32.0764026,19.521962 Z"
})));

var SvgBackArrow = function SvgBackArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "20px",
    viewBox: "0 0 26 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-arrow.740c154f.svg";
export { ForwardRef as ReactComponent };